// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-0a96b6c1]{background:none}.finish_box h1[data-v-0a96b6c1]{letter-spacing:-.7px!important}", ""]);
// Exports
module.exports = exports;
